import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  smData: null,
  permission: null,
  error: null,
  loading: false,
  token: null,

  userGetData: null,
  userListGetData: null,
  userCreateData: null,
  userUpdateData: null,

  hmgGetData: null,
  hmgCreateData: null,
  hmgUpdateData: null,
  hmgHotelData: null,
  hmgProjectHotelData: null,

  hmgMainGetData: null,
  hmgMainCreateData: null,
  hmgMainUpdateData: null,

  hotelGetData: null,
  hotelCreateData: null,
  hotelUpdateData: null,

  rolesGetData: null,
  rolesListGetData: null,
  roleCreateData: null,
  roleUpdateData: null,

  reportsGetData: null,

  indexesGetData: null,
  indexeCreateData: null,
  indexeUpdateData: null,

  pmsGetData: null,

  solutionsGetData: null,

  mainRolesGetData: null,
  mainRoleCreateData: null,
  mainRoleUpdateData: null,

  applicationsGetData: null,
  applicationsCreateData: null,

  hotelsGroupsGetData: null,
  hotelsGroupCreateData: null,
  hotelsGroupUpdateData: null,

  signersGroupsGetData: null,
  signersGroupCreateData: null,
  signersGroupUpdateData: null,
  signersGroupsHotelUpdateData: null,

  bulkUserCreationData: null,

  deleteItemData: null,

  outOfOfficeCreateData: null,
  outOfOfficeUpdateData: null,
};

const apiStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true,
  });
};

const apiComplete = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
  });
};
const apiFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const setNull = (state, action) => {
  return updateObject(state, {
    [action.data]: null,
  });
};

const setSmDataStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true,
  });
};

const setSmDataSuccess = (state, action) => {
  return updateObject(state, {
    smData: action.data,
    permission: action.data.data.permission,
    error: null,
    loading: false,
  });
};

const userGetSuccess = (state, action) => {
  return updateObject(state, {
    userGetData: action.data,
    error: null,
    loading: false,
  });
};
const userListGetSuccess = (state, action) => {
  return updateObject(state, {
    userListGetData: action.data,
    error: null,
    loading: false,
  });
};
const userCreateSuccess = (state, action) => {
  const sendData = {};
  if (
    state.userGetData &&
    state.userGetData.data &&
    action.data &&
    action.data.data &&
    action.data.data._id
  ) {
    sendData.data = state.userGetData.data;
    sendData.data.unshift(action.data.data);
  } else {
    sendData.data = state.userGetData.data;
  }
  return updateObject(state, {
    userCreateData: action.data,
    userGetData: sendData,
    error: null,
    loading: false,
  });
};
const userUpdateSuccess = (state, action) => {
  const sendData = {};
  if (
    state.userGetData &&
    state.userGetData.data &&
    action.data &&
    action.data.data &&
    action.data.data._id
  ) {
    const index = state.userGetData.data.findIndex(
      (d) => d._id.toString() === action.data.data._id.toString()
    );
    state.userGetData.data[index] = action.data.data;
    sendData.data = state.userGetData.data;
  } else {
    sendData.data = state.userGetData.data;
  }
  return updateObject(state, {
    userUpdateData: action.data,
    userGetData: sendData,
    error: null,
    loading: false,
  });
};

const hmgGetSuccess = (state, action) => {
  return updateObject(state, {
    hmgGetData: action.data,
    error: null,
    loading: false,
  });
};
const hmgCreateSuccess = (state, action) => {
  return updateObject(state, {
    hmgCreateData: action.data,
    error: null,
    loading: false,
  });
};
const hmgUpdateSuccess = (state, action) => {
  return updateObject(state, {
    hmgUpdateData: action.data,
    error: null,
    loading: false,
  });
};
const hmgHotelListSuccess = (state, action) => {
  return {
    ...state,
    hmgHotelData: action.data,
    error: null,
    loading: false,
  };
};

const hmgProjectsHotelListSuccess = (state, action) => {
  return {
    ...state,
    hmgProjectHotelData: action.data,
    error: null,
    loading: false,
  };
};

const hmgMainGetSuccess = (state, action) => {
  return updateObject(state, {
    hmgMainGetData: action.data,
    error: null,
    loading: false,
  });
};
const hmgMainCreateSuccess = (state, action) => {
  return updateObject(state, {
    hmgMainCreateData: action.data,
    error: null,
    loading: false,
  });
};
const hmgMainUpdateSuccess = (state, action) => {
  return updateObject(state, {
    hmgMainUpdateData: action.data,
    error: null,
    loading: false,
  });
};

const hotelGetSuccess = (state, action) => {
  return updateObject(state, {
    hotelGetData: action.data,
    error: null,
    loading: false,
  });
};
const hotelCreateSuccess = (state, action) => {
  const sendData = {};
  let sendData2 = {};
  if (
    state.hotelGetData &&
    state.hotelGetData.data &&
    action.data &&
    action.data.data &&
    action.data.data._id
  ) {
    sendData.data = state.hotelGetData.data;
    sendData.data.unshift(action.data.data);
  } else {
    sendData.data = state.hotelGetData.data;
  }

  if (
    state.userGetData &&
    state.userGetData.data &&
    action.data &&
    action.data.data2 &&
    action.data.data2.length > 0
  ) {
    console.log("Ok 1");

    for (const d1 of action.data.data2) {
      const index = state.userGetData.data.findIndex(
        (d) => d._id.toString() === d1._id.toString()
      );
      state.userGetData.data[index] = d1;
    }
    sendData2.data = state.userGetData.data;
  } else {
    sendData2 = state.userGetData;
  }

  return updateObject(state, {
    hotelCreateData: action.data,
    hotelGetData: sendData,
    userGetData: sendData2,
    error: null,
    loading: false,
  });
};
const hotelUpdateSuccess = (state, action) => {
  const sendData = {};
  if (
    state.hotelGetData &&
    state.hotelGetData.data &&
    action.data &&
    action.data.data &&
    action.data.data._id
  ) {
    const index = state.hotelGetData.data.findIndex(
      (d) => d._id.toString() === action.data.data._id.toString()
    );
    state.hotelGetData.data[index] = action.data.data;
    sendData.data = state.hotelGetData.data;
  } else {
    sendData.data = state.hotelGetData.data;
  }
  return updateObject(state, {
    hotelUpdateData: action.data,
    hotelGetData: sendData,
    error: null,
    loading: false,
  });
};

const rolesGetSuccess = (state, action) => {
  return updateObject(state, {
    rolesGetData: action.data,
    error: null,
    loading: false,
  });
};

const rolesListGetSuccess = (state, action) => {
  return updateObject(state, {
    rolesListGetData: action.data,
    error: null,
    loading: false,
  });
};
const roleCreateSuccess = (state, action) => {
  return updateObject(state, {
    roleCreateData: action.data,
    error: null,
    loading: false,
  });
};
const roleUpdateSuccess = (state, action) => {
  return updateObject(state, {
    roleUpdateData: action.data,
    error: null,
    loading: false,
  });
};

const reportsGetSuccess = (state, action) => {
  return updateObject(state, {
    reportsGetData: action.data,
    error: null,
    loading: false,
  });
};

const indexesGetSuccess = (state, action) => {
  return updateObject(state, {
    indexesGetData: action.data,
    error: null,
    loading: false,
  });
};
const indexeCreateSuccess = (state, action) => {
  return updateObject(state, {
    indexeCreateData: action.data,
    error: null,
    loading: false,
  });
};
const indexeUpdateSuccess = (state, action) => {
  return updateObject(state, {
    indexeUpdateData: action.data,
    error: null,
    loading: false,
  });
};

const pmsGetSuccess = (state, action) => {
  return updateObject(state, {
    pmsGetData: action.data,
    error: null,
    loading: false,
  });
};

const solutionsGetSuccess = (state, action) => {
  return updateObject(state, {
    solutionsGetData: action.data,
    error: null,
    loading: false,
  });
};

const mainRolesGetSuccess = (state, action) => {
  return updateObject(state, {
    mainRolesGetData: action.data,
    error: null,
    loading: false,
  });
};
const mainRoleCreateSuccess = (state, action) => {
  return updateObject(state, {
    mainRoleCreateData: action.data,
    error: null,
    loading: false,
  });
};
const mainRoleUpdateSuccess = (state, action) => {
  return updateObject(state, {
    mainRoleUpdateData: action.data,
    error: null,
    loading: false,
  });
};

const applicationsGetSuccess = (state, action) => {
  return updateObject(state, {
    applicationsGetData: action.data,
    error: null,
    loading: false,
  });
};

const hotelsGroupsGetSuccess = (state, action) => {
  return updateObject(state, {
    hotelsGroupsGetData: action.data,
    error: null,
    loading: false,
  });
};
const hotelsGroupCreateSuccess = (state, action) => {
  return updateObject(state, {
    hotelsGroupCreateData: action.data,
    error: null,
    loading: false,
  });
};
const hotelsGroupUpdateSuccess = (state, action) => {
  return updateObject(state, {
    hotelsGroupUpdateData: action.data,
    error: null,
    loading: false,
  });
};

const signersGroupsGetSuccess = (state, action) => {
  return updateObject(state, {
    signersGroupsGetData: action.data,
    error: null,
    loading: false,
  });
};
const signersGroupCreateSuccess = (state, action) => {
  return updateObject(state, {
    signersGroupCreateData: action.data,
    error: null,
    loading: false,
  });
};
const signersGroupUpdateSuccess = (state, action) => {
  return updateObject(state, {
    signersGroupUpdateData: action.data,
    error: null,
    loading: false,
  });
};
const signersGroupsHotelUpdateSuccess = (state, action) => {
  return updateObject(state, {
    signersGroupsHotelUpdateData: action.data,
    error: null,
    loading: false,
  });
};

const bulkUserCreationSuccess = (state, action) => {
  return updateObject(state, {
    bulkUserCreationData: action.data,
    error: null,
    loading: false,
  });
};

const deleteItemSuccess = (state, action) => {
  return updateObject(state, {
    deleteItemData: action.data,
    error: null,
    loading: false,
  });
};

const outOfOfficeCreateSuccess = (state, action) => {
  return updateObject(state, {
    outOfOfficeCreateData: action.data,
    error: null,
    loading: false,
  });
};
const outOfOfficeUpdateSuccess = (state, action) => {
  return updateObject(state, {
    outOfOfficeUpdateData: action.data,
    error: null,
    loading: false,
  });
};

const setSmDataFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.API_START:
      return apiStart(state, action);
    case actionTypes.API_COMPLETE:
      return apiComplete(state, action);
    case actionTypes.API_FAIL:
      return apiFail(state, action);
    case actionTypes.SET_NULL:
      return setNull(state, action);
    case actionTypes.SET_SM_DATA_START:
      return setSmDataStart(state, action);
    case actionTypes.SET_SM_DATA_SUCCESS:
      return setSmDataSuccess(state, action);
    case actionTypes.SET_SM_DATA_FAIL:
      return setSmDataFail(state, action);
    case actionTypes.USER_GET_SUCCESS:
      return userGetSuccess(state, action);
    case actionTypes.USER_LIST_GET_SUCCESS:
      return userListGetSuccess(state, action);
    case actionTypes.USER_CREATE_SUCCESS:
      return userCreateSuccess(state, action);
    case actionTypes.USER_UPDATE_SUCCESS:
      return userUpdateSuccess(state, action);

    case actionTypes.HMG_GET_SUCCESS:
      return hmgGetSuccess(state, action);
    case actionTypes.HMG_CREATE_SUCCESS:
      return hmgCreateSuccess(state, action);
    case actionTypes.HMG_UPDATE_SUCCESS:
      return hmgUpdateSuccess(state, action);
    case actionTypes.HMG_GET_HOTELS_SUCCESS:
      return hmgHotelListSuccess(state, action);
    case actionTypes.HMG_GET_PROJECTS_HOTELS_SUCCESS:
      return hmgProjectsHotelListSuccess(state, action);

    case actionTypes.HMG_MAIN_GET_SUCCESS:
      return hmgMainGetSuccess(state, action);
    case actionTypes.HMG_MAIN_CREATE_SUCCESS:
      return hmgMainCreateSuccess(state, action);
    case actionTypes.HMG_MAIN_UPDATE_SUCCESS:
      return hmgMainUpdateSuccess(state, action);

    case actionTypes.HOTEL_GET_SUCCESS:
      return hotelGetSuccess(state, action);
    case actionTypes.HOTEL_CREATE_SUCCESS:
      return hotelCreateSuccess(state, action);
    case actionTypes.HOTEL_UPDATE_SUCCESS:
      return hotelUpdateSuccess(state, action);

    case actionTypes.ROLES_GET_SUCCESS:
      return rolesGetSuccess(state, action);
    case actionTypes.ROLES_LIST_GET_SUCCESS:
      return rolesListGetSuccess(state, action);
    case actionTypes.ROLE_CREATE_SUCCESS:
      return roleCreateSuccess(state, action);
    case actionTypes.ROLE_UPDATE_SUCCESS:
      return roleUpdateSuccess(state, action);

    case actionTypes.REPORTS_GET_SUCCESS:
      return reportsGetSuccess(state, action);

    case actionTypes.INDEXES_GET_SUCCESS:
      return indexesGetSuccess(state, action);
    case actionTypes.INDEXE_CREATE_SUCCESS:
      return indexeCreateSuccess(state, action);
    case actionTypes.INDEXE_UPDATE_SUCCESS:
      return indexeUpdateSuccess(state, action);

    case actionTypes.PMS_GET_SUCCESS:
      return pmsGetSuccess(state, action);

    case actionTypes.SOLUTIONS_GET_SUCCESS:
      return solutionsGetSuccess(state, action);

    case actionTypes.MAIN_ROLES_GET_SUCCESS:
      return mainRolesGetSuccess(state, action);
    case actionTypes.MAIN_ROLE_CREATE_SUCCESS:
      return mainRoleCreateSuccess(state, action);
    case actionTypes.MAIN_ROLE_UPDATE_SUCCESS:
      return mainRoleUpdateSuccess(state, action);

    case actionTypes.APPLICATIONS_GET_SUCCESS:
      return applicationsGetSuccess(state, action);

    case actionTypes.HOTELS_GROUPS_GET_SUCCESS:
      return hotelsGroupsGetSuccess(state, action);
    case actionTypes.HOTELS_GROUP_CREATE_SUCCESS:
      return hotelsGroupCreateSuccess(state, action);
    case actionTypes.HOTELS_GROUP_UPDATE_SUCCESS:
      return hotelsGroupUpdateSuccess(state, action);

    case actionTypes.SIGNERS_GROUPS_GET_SUCCESS:
      return signersGroupsGetSuccess(state, action);
    case actionTypes.SIGNERS_GROUP_CREATE_SUCCESS:
      return signersGroupCreateSuccess(state, action);
    case actionTypes.SIGNERS_GROUP_UPDATE_SUCCESS:
      return signersGroupUpdateSuccess(state, action);
    case actionTypes.SIGNERS_GROUPS_HOTEL_UPDATE_SUCCESS:
      return signersGroupsHotelUpdateSuccess(state, action);

    case actionTypes.BULK_USER_CREATION_SUCCESS:
      return bulkUserCreationSuccess(state, action);

    case actionTypes.DELETE_ITEM_SUCCESS:
      return deleteItemSuccess(state, action);

    case actionTypes.OUT_OF_OFFICE_CREATE_SUCCESS:
      return outOfOfficeCreateSuccess(state, action);
    case actionTypes.OUT_OF_OFFICE_UPDATE_SUCCESS:
      return outOfOfficeUpdateSuccess(state, action);

    default:
      return state;
  }
};

export default reducer;
